import AddImg from './components/addImg'
import {NavbarTopAdmin, NavbarBottomAdmin} from './components'
import AuthProvider from '../Authentication/authProvider'
import { useState } from 'react'
import axios from 'axios'
import ReactQuill from 'react-quill-new'
import 'react-quill-new/dist/quill.snow.css'

function AddNewsletter() {
    const [formData, setFormData] = useState({
        created_at: new Date().toLocaleDateString('it-IT'),
        foto: [],
        testo1: '',
        testo2: '',
        footer: ''
    })
    const [result, setResult] = useState('')

    async function handleSubmit(e) {
        e.preventDefault()
        if (formData.foto.length !== 8) {alert('mancano delle foto'); return}
        if (formData.testo1.length > 4999 || formData.testo2.length > 4999) { alert('testo1 o testo2 troppo lunghi'); return }
        if (formData.footer.length > 2999) { alert('footer troppo lungo'); return }
        if (formData.testo1.length === 0 || formData.testo2.length === 0 || formData.footer.length === 0) {alert('mancano dei contenuti'); return}
        try {
            const res = await axios.post('/createNewsletter', formData)
            console.log('id newsletter:', res.data)
            setResult('*** Comunicato stampa inserito ***')
        } catch (error) {
            setResult('*** problemi con il server ***')
            console.error("Si è verificato un errore: " + error.message)
        }
    }
    function handleInputChange(e) {
        const { name, value, type, checked } = e.target
        const inputValue = type === "checkbox" ? checked : value
        setFormData({ ...formData, [name]: inputValue })
    }
    function handleDescrizione(e) {
        setFormData({ ...formData, testo1: e })
    }
    function handleDescrizione2(e) {
        setFormData({ ...formData, testo2: e })
    }
    function handleFooter(e) {
        setFormData({ ...formData, footer: e })
    }

    // useEffect(() => { console.log(formData) }, [formData])
    return (<>
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <AuthProvider />
        <div className='homePadding mt-5'>
            <form onSubmit={handleSubmit} className='mt-1'>
                <h3>Aggiungi card in Food&Travel</h3>
                <div className='p-3'>
                    <label>CardTitle</label>
                    <input className="form-control" name='cardTitle' maxLength={200} required onChange={handleInputChange} type='text' />

                    <label className='mt-2'>cardText</label>
                    <input className="form-control" name='cardText' maxLength={300} required onChange={handleInputChange} type='text' />
                </div> <hr />

                <h3 className='mt-5'>NewsletterDetails</h3>
                <div className='p-3'>
                    <label className='mt-1'>Titolo</label>
                    <input className="form-control" name='title' maxLength={300} required onChange={handleInputChange} type='text' />
                    <label className='mt-2'>sottotitolo</label>
                    <input className="form-control" name='sottotitolo' maxLength={300} required onChange={handleInputChange} type='text' />
                    <label className='mt-2'>fotoBottom</label>
                    <input className="form-control" name='fotoBottom' maxLength={200} required onChange={handleInputChange} type='text' />
                </div>

                <h5 className='mt-1'><b>Corpo</b></h5>
                <div className='p-3'>
                    <ReactQuill className="textarea-quill mt-1"/*ql-container è la classe in App.css */
                        theme="snow"
                        onChange={handleDescrizione}
                        placeholder="Titolo e testo"
                        modules={{
                            toolbar: [
                                ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                ['link'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                            ]
                        }}
                    />
                    <p className='text-danger'><i>{formData.testo1.length} *** max 5000</i></p>
                    <ReactQuill className="textarea-quill mt-3"/*ql-container è la classe in App.css */
                        theme="snow"
                        onChange={handleDescrizione2}
                        placeholder="Titolo e testo"
                        modules={{
                            toolbar: [
                                ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                ['link'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                            ]
                        }}
                    />
                    <p className='text-danger'><i>{formData.testo2.length} *** max 5000</i></p>
                </div>

                <h5 className='mt-1'><b>Footer</b></h5>
                <div className='p-3'>
                    <ReactQuill className="textarea-quill mt-3"/*ql-container è la classe in App.css */
                        theme="snow"
                        onChange={handleFooter}
                        placeholder="Titolo e testo"
                        modules={{
                            toolbar: [
                                ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                ['link'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                            ]
                        }}
                    />
                    <p className='text-danger'><i>{formData.footer.length} *** max 3000</i></p>

                    <label className='mt-1'>Nome intestatario</label>
                    <input className="form-control" name='nome' required maxLength={20} onChange={handleInputChange} type='text' />

                    <label className='mt-1'>Ruolo intestatario</label>
                    <input className="form-control" name='ruolo' placeholder='direttore eventi.com' maxLength={40} onChange={handleInputChange} type='text' />

                    <label className='mt-1'>Email intestatario</label>
                    <input className="form-control" name='email' maxLength={40} onChange={handleInputChange} type='text' />

                    <label className='mt-1'>Sito web</label>
                    <input className="form-control" name='sito' maxLength={100} onChange={handleInputChange} type='text' />
                </div>

                <div className='mt-5'><b>Ordine di inserimento foto:</b><br />
                    1. Card img<br />
                    2. Foto alto in details<br />
                    3. Prima foto nel corpo del testo<br />
                    4. Seconda foto nel corpo del testo<br />
                    5. Terza foto nel corpo del testo<br />
                    6. Quarta foto nel corpo del testo<br />
                    7. Foto a sinistra (orizzontale) nel footer<br />
                    8. Foto a destra (verticale) nel footer<br />
                </div>
                <AddImg numero={[0, 1, 2, 3, 4, 5, 6, 7]} folder={'newsletter/'} invioFoto={(e) => { setFormData({ ...formData, foto: e }) }} />
                <button type='submit' className='btn btn-primary'>INVIA</button>
                {result && <p className='mt-2'>{result}</p>}
            </form>
        </div>
    </>)
}
export default AddNewsletter